import React from 'react';
import '../../css/loader.css';

function NextBtnLoader() {

    return (
        <div>
            <div className="loader-overlay-1">
                <div className="spinner"></div>
                </div>
        </div>

    );
}

export default NextBtnLoader;
